import React from 'react';

export const StepHeader = ({ title, text }: StepHeaderProps) => {
  return (
    <div className={'flex flex-col gap-1 mt-8'}>

      <h4>{title}</h4>

      <div className={'flex flex-col gap-8'}>

        <span>{text}</span>

        <span className={'text-sm text-[#484D7A]'}>Les champs marqués d’un * sont obligatoires</span>
      </div>
    </div>
  );
};

interface StepHeaderProps {
  title: string;
  text: string;
}